module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.33991/images/pngs/onboarding-assistant-logo.png"